import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";
import { Backdrop } from "./shapes";

/** Calendar day cells: [x, y, filled]. A short run is filled to read "weeks". */
const CELLS: ReadonlyArray<[number, number, boolean]> = [
  [80, 60, false],
  [98, 60, false],
  [116, 60, true],
  [134, 60, true],
  [80, 78, true],
  [98, 78, true],
  [116, 78, true],
  [134, 78, false],
];

/**
 * Flat illustration for "Ship in weeks": a calendar with a short run of days
 * marked — a working product in weeks, not quarters.
 */
export function SpeedIllustration() {
  return (
    <IllustrationSvg>
      {/* Soft backdrop */}
      <Backdrop x={44} y={22} width={132} height={94} />
      {/* Binding rings */}
      <rect
        x="88"
        y="30"
        width="5"
        height="12"
        rx="2.5"
        fill={colors.textPrimary}
      />
      <rect
        x="127"
        y="30"
        width="5"
        height="12"
        rx="2.5"
        fill={colors.textPrimary}
      />
      {/* Calendar body */}
      <rect
        x="70"
        y="36"
        width="80"
        height="74"
        rx="9"
        fill={colors.paper}
        stroke={colors.divider}
        strokeWidth="2"
      />
      {/* Header band */}
      <path
        d="M70 45a9 9 0 0 1 9-9h62a9 9 0 0 1 9 9v7H70z"
        fill={colors.primary}
      />
      {/* Day cells */}
      {CELLS.map(([x, y, filled]) => (
        <rect
          key={`${x}-${y}`}
          x={x}
          y={y}
          width="12"
          height="10"
          rx="3"
          fill={filled ? colors.primary : colors.divider}
          opacity={filled ? 0.55 : 0.7}
        />
      ))}
      {/* Done check on the last marked day */}
      <path
        d="M119 82l2.4 2.6 5-5.6"
        fill="none"
        stroke={colors.success}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IllustrationSvg>
  );
}
